import React from 'react'

export const getTruncatedLabel = (label: string): React.ReactNode => {
  const max = 20
  return label.length < max ? <tspan>{label}</tspan> : <tspan>{label.substr(0, max - 2)}..</tspan>
}
